<template>
  <div class="yoeContainer" :class="{fullScreen: fullScreen, [pathName]:true}">
    <div class="header">
      <div class="">
        <div class="">
          <img class="landingHeader" src="../assets/images/landing/landing_page_header.jpg">
        </div>
      </div>
    </div>
    <div class="container" style="min-height: calc(100vh - 390px)">
      <div class="row">
        <div class="col">

          <!-- Page Content -->
          <div class="pageContentContainer">
            <img class="landingHeading" src="../assets/images/landing/landing_title.png"/>
            <div class="explanationContainer" v-if="audience == 'teachers'">
              <p>It’s not just the Children of Thanos that are threatening Earth’s security, our planet is facing new challenges every single day. Engineers are the people to solve them.</p>
              <p>This Winter, Marvel and the Year of Engineering have teamed up to show students that engineers are everyday Super Heroes. Using popular Super Heroes, we’ll encourage students everywhere to unleash their superpowers and look at engineering a different way. We’ve created the More Heroes Needed Aptitude Test to help students identify the Super Hero they are most like and then to discover how they can apply their strengths in the world of engineering.</p>
              <a href="./download/school_resources.zip" download="lesson plan"  class="downloadLessonButton" @click="notifyGoogleDownload()">Download the lesson plan</a>
              <a href="/" class="startTestButton startTestButton--overlay">
                <img src="../assets/images/landing/parallax/bg.jpg">
                <div class="landingLayers">
                  <img class="spark--back" src="../assets/images/landing/parallax/spark-b.png">
                  <img class="spark--middle" src="../assets/images/landing/parallax/spark-m.png">

                  <img class="hero--wasp" src="../assets/images/landing/parallax/hero-w.png">
                  <img class="hero--hulk" src="../assets/images/landing/parallax/hero-h.png">
                  <img class="hero--front" src="../assets/images/landing/parallax/hero-f.png">

                  <img class="spark--front" src="../assets/images/landing/parallax/spark-f.png">
                </div>
                <p class="startTestButtonText">Go to the aptitude test</p>
              </a>
            </div>
            <div class="explanationContainer" v-if="audience == 'students'">
              <p>It’s not just the Children of Thanos that are threatening Earth’s security, our planet is facing  new challenges every single day.</p>
              <p>We need more Super Heroes than ever before. We’re calling on strong, smart, brave and loyal heroes to save our planet. Do you have what it takes to protect us?</p>
              <a class="startTestButton" :class="{testStared: beginTest}" @click="beginTestMethod()">
                <img src="../assets/images/landing/parallax/bg.jpg">
                <div class="landingLayers">
                  <img class="spark--back" src="../assets/images/landing/parallax/spark-b.png">
                  <img class="spark--middle" src="../assets/images/landing/parallax/spark-m.png">

                  <img class="hero--wasp" src="../assets/images/landing/parallax/hero-w.png">
                  <img class="hero--hulk" src="../assets/images/landing/parallax/hero-h.png">
                  <img class="hero--front" src="../assets/images/landing/parallax/hero-f.png">

                  <img class="spark--front" src="../assets/images/landing/parallax/spark-f.png">
                </div>
                <p class="startTestButtonText">Take the aptitude test</p>
              </a>
            </div>
          </div>
          <a target="_blank" href="https://www.yearofengineering.gov.uk/">
            <img class="engineeringImage" src="../assets/images/landing/engineering.png"/>
          </a>
        </div>
      </div>
    </div>
    <!-- Page Footer -->
    <div class="footerContainer">
      <div class="container">
        <div class="row">
          <div class="col">
              <div class="footer">
                <img class="logo-footer" src="../assets/images/landing/hm-government-logo-white.svg" alt="HM Goverment logo" title="A HM Goverment's website">
                <div class="list-menu-footer">
                  <ul>
                    <li id="accessibility">
                      <a href="https://www.yearofengineering.gov.uk/accessibility">Accessibility</a>
                    </li>
                    <li id="policy">
                      <a href="https://www.yearofengineering.gov.uk/policy">Privacy Policy</a>
                    </li>
                    <li id="terms">
                      <a href="https://www.yearofengineering.gov.uk/terms">Terms &amp; Conditions</a>
                    </li>
                    <li id="copyright">
                      <a href="https://www.yearofengineering.gov.uk/copyright">Copyright</a>
                    </li>
                    <li id="contact">
                      <a href="https://www.yearofengineering.gov.uk/contact">Contact</a>
                    </li>
                    <li id="sitemap">
                      <a href="https://www.yearofengineering.gov.uk/sitemap">Sitemap</a>
                    </li>
                  </ul>
                  <div class="list-menu-footer-text"> © 2018 Year of Engineering </div>
                </div>
                <div class="list-social-icon">
                  <ul>
                    <li>
                      <a href="https://www.instagram.com/yearofengineering" target="_blank">
                        <img src="../assets/images/landing/instagram.svg" alt="instagram icon" title="Follow us on instagram">
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/channel/UCj-GzW4dmqdZTjDNhlZ3KQw/" target="_blank">
                        <img src="../assets/images/landing/youtube.svg" alt="youtube icon" title="Follow us on youtube">
                      </a>
                    </li>
                    <li>
                      <a href="https://www.facebook.com/yearofengineering" target="_blank">
                        <img src="../assets/images/landing/facebook.svg" alt="facebook icon" title="Follow us on facebook">
                      </a>
                    </li>
                    <li>
                      <a href="https://twitter.com/yoegovuk?lang=en" target="_blank">
                        <img src="../assets/images/landing/twitter.svg" alt="twitter icon" title="Follow us on twitter">
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            
          </div>
        </div>
      </div>
    </div>

    <!-- The Test -->
    <div class="fullTestContainer" :class="{startTest: beginTest, gameIsBeingPlayed: playingGame}" >
      <!-- <a class="genericButton closeTestLink" @click="beginTest = false">Close Test</a> -->
      <div class="testDisplayRow__wrap">  
        <div class="testDisplayRow ten-six" :style="{ transform: 'scale(' + gameScale + ')'}">
          <div class="content gameFrameContainer">

            <a class="fullscreenLink" :class="{isFullscreen: fullScreen}" @click="toggleFullScreen()">
              <img v-if="fullScreen" src="../assets/images/close_full_x2.png">
              <img v-else src="../assets/images/MoreHeroesNeeded_Exit_x2.png">
            </a>

            <a class="marvelLogoImage" href="https://www.marvel.com/">
              <img src="../assets/images/marvel-logo.png">
            </a>
            
            <img class="engineeringLogoImage" src="../assets/images/engineering-logo.png">
            <img class="moreLogoImage" src="../assets/images/more-needed-logo.png">
            <p class="marvelLegal">©2018 MARVEL</p>
            
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>

          </div>
        <!-- <p class="dataItem">data: {{ questionStoredata }}</p> -->
        </div>
      </div>
    </div>

    <!-- small screen display -->
    <div class="screenIsTooSmall" v-if="beginTest">
      <h1>Please turn device or use a larger screen.</h1>
    </div>

    <!-- Preloaded Images -->

    <img src="../assets/images/start/start_bg.jpg" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/start/start_s1.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/start/start_iron_man.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/start/start_black_panther.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/start/start_hulk.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/start/start_rocket.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/start/start_wasp.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/start/start_s2.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/start/start_moreLogo.png" alt="Preloaded Image" class="preloadImage">
    <img src="../assets/images/start/start_s3.png" alt="Preloaded Image" class="preloadImage">    
    <img src="../assets/images/start/get-started.png" alt="Preloaded Image" class="preloadImage">    
  </div>
</template>


<script>
export default {
  name: "Home",
  data() {
    return {
      pathName: '',
      audience: '',
      window: {
        width: 0,
        height: 0
      },
      gameScale: 1,
      beginTest: false,
      fullScreen: false
    };
  },
  computed: {
    questionStoredata() {
      return this.$store.getters.StoreQuestionData
    },
    playingGame () {
      return this.$store.getters.StoreQuestionData.playingGame
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },
  mounted() {
    this.setFirstPage()
    this.pathName = 'page--' + this.$route.path.substring(1)
    if (this.questionStoredata.total > 0) {
      this.$router.push('/start')
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  watch: {
    '$route.path' () {
      this.pathName = 'page--' + this.$route.path.substring(1)
      this.trackPage()
    },
    audience () {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  },
  methods: {
    notifyGoogleDownload() {
      console.log('notified')
      this.$ga.event({
        eventCategory: 'teacher',
        eventAction: 'download',
        eventValue: 1
      })
    },
    trackPage() {
      this.$ga.page(this.$router)
    },
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      this.scaleGame()
    },
    scaleGame() {
      let scaleHeight = window.innerHeight / 735;
      let scaleWidth = window.innerWidth / 1200;

      if (735 * scaleWidth > window.innerHeight) {
        this.gameScale = scaleHeight
      } else {
        this.gameScale = scaleWidth
      }

    },
    setFirstPage() {
      if (this.$route.path.substring(1) == 'teachers') {
        this.audience = 'teachers'
      } else {
        this.audience = 'students'
      }
    },
    beginTestMethod() {
      if (this.questionStoredata.total == 0) {
        this.$router.push('/start')
      }
      if (!this.beginTest) {
        this.beginTest = true
        this.toggleFullScreen()
        this.$store.dispatch('updateStart', true)
      }
    },
    toggleFullScreen() {
      if ( (document.fullScreenElement && document.fullScreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen) ) {
        this.fullScreen = true
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        this.$store.dispatch('updateStart', false)
        this.beginTest = false
        this.fullScreen = false
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    }
  }
};
</script>

